import React from "react";
import { Box, Button, CircularProgress, Typography } from "@material-ui/core";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import DescriptionIcon from "@material-ui/icons/Description";
import { useSnapshotReport } from "./useSnapshotReport";

/**
 * "Print a blank field sheet" buttons — generates an empty version of the
 * Snapshot Report (fill-in lines, empty tables) for staff to take on site
 * visits. PDF opens the print dialog; Word downloads a .docx.
 */
const BlankTemplateButtons = () => {
  const { generateBlank, generating, printMarkup } = useSnapshotReport();

  const busy = (format) =>
    generating?.irNdx === "blank" && generating?.format === format;

  return (
    <Box display="flex" alignItems="center" gridGap={8}>
      <Typography variant="body2" color="textSecondary">
        Blank field sheet:
      </Typography>
      <Button
        size="small"
        variant="outlined"
        color="primary"
        disabled={!!generating}
        startIcon={
          busy("pdf") ? <CircularProgress size={16} /> : <PictureAsPdfIcon />
        }
        onClick={() => generateBlank("pdf")}
      >
        PDF
      </Button>
      <Button
        size="small"
        variant="outlined"
        color="primary"
        disabled={!!generating}
        startIcon={
          busy("docx") ? <CircularProgress size={16} /> : <DescriptionIcon />
        }
        onClick={() => generateBlank("docx")}
      >
        Word
      </Button>
      {printMarkup}
    </Box>
  );
};

export default BlankTemplateButtons;
